<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t('new_batch') }}</h4>
        </div>
      </div>
      <ul class="table-top-head">
        <li>
          <div class="page-btn">
            <router-link to="/batches" class="btn btn-added">
              <span>Back</span>
            </router-link>
          </div>
        </li>
        <li>
          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
        </li>
      </ul>
    </div>

    <div class="card table-list-card p-3 bg-white fs-7">
    <form @submit.prevent="submitBatch" enctype="multipart/form-data">
      <!-- Header Form Section -->
      <div class="row gy-2 gx-4 mb-3 justify-content-between align-items-center">
        <div class="col-md-6 d-flex align-items-center">
          <label class="form-label small mb-0 me-3" style="width:200px;">{{$t("receiving_no")}}</label>
          <input type="text" class="form-control" v-model="batches.receiving_no" readonly/>
        </div>

        <div class="col-md-6 d-flex align-items-center">
          <label class="form-label small mb-0 me-3" style="width:200px;">{{$t("receiving_date")}}</label>
          <input type="date" class="form-control" v-model="batches.receiving_date" @change="fetchReceivingNo" />
          <div v-if="errors.receiving_date" class="text-danger mt-2">
            <span>{{errors.receiving_date}}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="d-flex align-items-center">
            <label class="form-label small mb-0 me-3" style="width:200px;">{{ $t("chalan_no") }} <span class="text-danger">*</span></label>
            <input type="text" class="form-control" v-model="batches.chalan_no" />
          </div>
          <div class="text-danger" style="height:0.75em; margin-left: 150px; font-size:0.875rem;">
            <span v-if="errors.chalan_no">{{ errors.chalan_no }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="d-flex align-items-center">
            <label class="form-label small mb-0 me-3" style="width:200px;">{{ $t("chalan_date") }} <span class="text-danger">*</span></label>
            <input type="date" class="form-control" v-model="batches.chalan_date" />
          </div>
          <div class="text-danger" style="height:0.75em; margin-left: 150px; font-size:0.875rem;">
            <span v-if="errors.chalan_date">{{ errors.chalan_date }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="d-flex align-items-center">
            <label class="form-label small mb-0 me-3" style="width:200px;">{{ $t('warehouse_name') }} <span class="text-danger">*</span></label>
            <VueSelect2
              v-model="batches.warehouse_id"
              :options="formattedwarehouses"
              :settings="{
                placeholder: $t('select_an_option'),
                allowClear: true,
                tags: true,
              }"
              @change="onChange"
              class="form-control"
            />
          </div>
          <div class="text-danger mt-1" style="height:0.75em; margin-left: 150px; font-size:0.875rem;">
            <span v-if="errors.warehouse_id">{{ errors.warehouse_id }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="d-flex align-items-center">
            <label class="form-label small mb-0 me-3" style="width:200px;">{{ $t('supplier_name') }} <span class="text-danger">*</span></label>
            <VueSelect2
              v-model="batches.supplier_id"
              :options="formattedsuppliers"
              :settings="{
                placeholder: $t('select_an_option'),
                allowClear: true,
                tags: true,
              }"
              @update:modelValue="selectSupplier"
              class="form-control"
            />
          </div>
          <div class="text-danger mt-1" style="height:0.75em; margin-left: 150px; font-size:0.875rem;">
            <span v-if="errors.supplier_id">{{ errors.supplier_id }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="d-flex align-items-center">
            <label class="form-label small mb-0 me-3" style="width:200px;">{{ $t("in_house_date") }} <span class="text-danger">*</span></label>
            <input type="date" class="form-control" v-model="batches.in_house_date" />
          </div>
          <div class="text-danger" style="height:0.75em; margin-left: 150px; font-size:0.875rem;">
            <span v-if="errors.in_house_date">{{ errors.in_house_date }}</span>
          </div>
        </div>

        <div class="col-md-6" v-if="selectedSupplier">
          <div class="d-flex align-items-start" style="min-height: 45px;">
            <label class="form-label small mb-1" style="width: 100px; white-space: nowrap;">
              Supplier Info:
            </label>

            <div class="text-start" style="font-size: 1rem; line-height: 1.4; word-break: break-word;">
              {{ selectedSupplier.name }} -
              {{ selectedSupplier.phone_number }} -
              <strong>Due:</strong>
              <span :style="{ color: selectedSupplier.due_balance > 0 ? 'red' : 'green' }">
                ৳{{ selectedSupplier.due_balance || 0 }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Item Input Section -->
      <div class="row g-2 mb-3 align-items-start fs-7">
        <div class="col">
          <div class="position-relative">
            <!-- Search Input -->
            <input
            type="text"
            v-model="query"
            @input="debouncedSearch"
            :placeholder="$t('search_item_by_name_code')"
            class="form-control"
            @keydown="handleKeys"
          />

            <!-- Dropdown Search Results -->
            <div
              v-if="query"
              class="search-results shadow rounded bg-white position-absolute mt-2"
              style="width:450px; max-height: 450px; overflow-y: auto; z-index: 1050; border: 1px solid #e0e0e0;"
              :class="{ 'd-block': results.length > 0, 'd-none': results.length === 0 }"
            >

            <!-- Results List -->
            <ul class="list-group list-group-flush">
              <li
                v-for="(item, index) in results"
                :key="item.id"
                class="list-group-item d-flex justify-content-between align-items-center"
                :class="{ 'bg-primary text-white': index === itemIndex }"
                style="padding: 10px; font-size: 0.95rem; cursor: pointer;"
              >
                <!-- Clickable Product Info -->
                <div
                  class="flex-grow-1 d-flex flex-column"
                  @click="selectItem(item)"
                  style="cursor: pointer;"
                >
                  <div class="d-flex align-items-center gap-2">
                    <!-- Image Wrapper -->
                    <div
                      style="width:50px; height:50px; border-radius:4px; overflow:hidden; flex-shrink:0;"
                    >
                      <img
                        :src="$getImageUrl(item.images)"
                        alt="Items"
                        style="width:100%; height:100%; object-fit:cover;"
                      />
                    </div>

                    <!-- Item Info -->
                    <div class="d-flex flex-column">
                      <strong class="text-dark">{{ item.item_name }} - {{ item.item_code }}</strong>
                      <span
                        style="font-size: 0.75rem; width: fit-content; color: black"
                      >
                        Stock: {{ item.stock_quantity }}
                      </span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <!-- No Results -->
            <div v-if="!results.length" class="text-center text-muted py-4" style="font-size: 1rem;">
              No results found
            </div>
          </div>
          </div>
        </div>

        <div class="col">
          <input type="text" class="form-control" :placeholder="$t('batch_no')" v-model="batches.batch_no" />
          <div class="text-danger mt-1" style="height:0.50em;">
            <span v-if="errors.batch_no">{{ errors.batch_no }}</span>
          </div>
        </div>

        <div class="col">
          <input type="text" class="form-control" :placeholder="$t('lot_no')" v-model="batches.lot_no" />
          <div class="text-danger mt-1" style="height:0.50em;">
            <span v-if="errors.lot_no">{{ errors.lot_no }}</span>
          </div>
        </div>

        <div class="col">
          <div class="input-group">
            <span class="input-group-text bg-white border-end-0">
              <i class="ti ti-calendar text-secondary"></i>
            </span>
            <input
              type="date"
              v-model="batches.manufacturing_date"
              :format="'yyyy-MM-dd'"
              class="form-control border-start-0"
              placeholder="Manufacturing Date"
            />
          </div>
          <div class="text-danger mt-1" style="height:0.50em;">
            <span v-if="errors.manufacturing_date">{{ errors.manufacturing_date }}</span>
          </div>
        </div>

        <div class="col">
          <div class="input-group">
            <span class="input-group-text bg-white border-end-0">
              <i class="ti ti-calendar text-secondary"></i>
            </span>
            <input
              type="date"
              v-model="batches.expiry_date"
              :format="'yyyy-MM-dd'"
              class="form-control border-start-0"
            />
          </div>
          <div class="text-danger mt-1" style="height:0.50em;">
            <span v-if="errors.expiry_date">{{ errors.expiry_date }}</span>
          </div>
        </div>

        <div class="col">
          <input type="number" class="form-control" :placeholder="$t('costing_unit_price')" v-model="batches.costing_unit_price" />
          <div class="text-danger mt-1" style="height:0.50em;">
            <span v-if="errors.costing_unit_price">{{ errors.costing_unit_price }}</span>
          </div>
        </div>

        <div class="col">
          <input type="number" class="form-control" :placeholder="$t('quantity')" v-model="batches.quantity" />
          <div class="text-danger mt-1" style="height:0.50em;">
            <span v-if="errors.quantity">{{ errors.quantity }}</span>
          </div>
        </div>

        <div class="col-auto">
          <button type="button" class="btn btn-info" @click="addItem">{{$t('add')}}</button>
        </div>
      </div>

      <!-- Items Table -->
      <div class="table-responsive mb-3 fixed-table">
        <table class="table table-bordered table-striped">
          <thead class="table-light">
            <tr>
              <th>{{ $t("item_name") }}</th>
              <th>{{ $t("batch_no") }}</th>
              <th>{{ $t("lot_no") }}</th>
              <th>{{ $t("manufacturing_date") }}</th>
              <th>{{ $t("expiry_date") }}</th>
              <th>{{ $t("unit_price") }}</th>
              <th>{{ $t("quantity") }}</th>
              <th>{{ $t("amount") }}</th>
              <th>{{ $t("action") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in addedItems" :key="index">
              <td>{{ item.item_name }}</td>
              <td>{{ item.batch_no }}</td>
              <td>{{ item.lot_no }}</td>
              <td>{{ item.manufacturing_date }}</td>
              <td>{{ item.expiry_date }}</td>
              <td>{{ item.costing_unit_price }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.amount }}</td>
              <td>
                <button type="button" class="btn btn-sm btn-danger" @click="removeItem(index)">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Payment Type -->
      <div class="d-flex justify-content-between align-items-start mt-4">
        <div class="d-flex gap-2 flex-grow-1">
          <div class="d-flex flex-column">
            <label class="form-label">
              {{$t('payment_type')}} <span class="text-danger">*</span>
            </label>
            <VueSelect2
              v-model="cash_type"
              :options="formattedcashtypes"
              :settings="{ allowClear: true, tags: true }"
              @change="onChange"
              class="form-control"
              style="width: 200px;"
            />
            <div v-if="errors.cash_type" class="text-danger">{{ errors.cash_type }}</div>
          </div>

          <div v-if="isBank" class="d-flex flex-column">
            <label class="form-label">
              {{$t('bank_account')}} <span class="text-danger">*</span>
            </label>
            <VueSelect2
              v-model="bank_account"
              :options="formattedbankaccounts"
              :settings="{ allowClear: true, tags: true }"
              @change="onChange"
              class="form-control"
              style="width: 200px;"
            />
            <div v-if="errors.bank_account" class="text-danger">{{ errors.bank_account }}</div>
          </div>

          <div class="col-auto d-flex flex-column">
            <label class="form-label">{{$t('reference_no')}} </label>
            <input
              type="text"
              v-model="reference_no"
              class="form-control"
              :placeholder= "$t('enter_reference_no')"
              style="width: 200px;"
            />
            <div v-if="errors.reference_no" class="text-danger">{{ errors.reference_no }}</div>
          </div>

          <!-- total, paid and due section -->
          <div class="col-auto ms-auto d-flex flex-column gap-2">
            <div class="d-flex align-items-center gap-1">
              <label class="form-label mb-0" style="width: 35px;">{{$t('total')}}</label>
              <input type="text" class="form-control text-end" :value="totalAmount" disabled />
            </div>
            <div class="d-flex align-items-center gap-1">
              <label class="form-label mb-0" style="width: 35px;">{{$t('paid')}}</label>
              <input type="number" class="form-control text-end no-spinner" v-model="paid" />
            </div>
            <div class="d-flex align-items-center gap-1">
              <label class="form-label mb-0" style="width: 35px;">{{$t('due')}}</label>
              <input type="text" class="form-control text-end" :value="dueAmount" disabled />
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
        <button type="submit" class="btn btn-submit" @click="onSubmit">{{ $t('submit') }}</button>
      </div>
    </form>
  </div>

  <!-- Due Confirmation Modal -->
  <div v-if="showDueModal" class="confirm-backdrop" click.self="cancelDueSale">
    <div class="confirm-modal">

      <div class="confirm-header">
        <h4>Due Purchase Confirmation</h4>
      </div>

      <div class="confirm-body">
        <div class="confirm-row">
          <span>Total Amount</span>
          <strong>৳ {{ totalAmount }}</strong>
        </div>

        <div class="confirm-row">
          <span>Paid Amount</span>
          <strong>৳ {{ paid }}</strong>
        </div>

        <div class="confirm-row due">
          <span>Due Amount</span>
          <strong>৳ {{ dueAmount }}</strong>
        </div>
      </div>

      <div class="confirm-actions">
        <button type="button" class="btn btn-secondary" @click="cancelDueSale">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" @click="confirmDueSale">
          Confirm Purchase
        </button>
      </div>

    </div>
  </div>
</div>
</template>

<script>
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import VueSelect2 from "vue3-select2-component";
import feather from "../../../../public/assets/js/feather.min";
import { useToast } from 'vue-toastification';
import debounce from 'lodash.debounce'

export default {
  components: {
    Vue3Datepicker,
    VueSelect2,
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      batches: {
        item: null, chalan_no: '', chalan_date: new Date().toISOString().split('T')[0], supplier_id: null, batch_no: '', lot_no: '', costing_unit_price: '',
        quantity: null, in_house_date: new Date().toISOString().split('T')[0], manufacturing_date: null, expiry_date: null, warehouse_id: null,
        receiving_no: '', receiving_date: new Date().toISOString().split('T')[0]

      },
      items: [],
      warehouses: [],
      suppliers: [],
      cash_types: [],
      errors: {},
      errorMessage: "",
      query: "",
      results: [],
      itemIndex: 0,
      selectedItem: null,
      addedItems: [],
      bank_accounts: [],
      paid: 0,
      reference_no: '',
      selectedSupplier: null,
      due_balance: 0,
      cash_type: null,
      bank_account: null,
      showDueModal: false,
      dueModalResolver: null,
      debouncedSearch: null
    };
  },

  mounted() {
    this.fetchDropdownData();
  },

  computed: {
    formattedItems() {
      return this.items.map(item => ({ id: item.id, text: item.item_name }));
    },

    formattedwarehouses() {
      return this.warehouses.map(warehouse => ({ id: warehouse.id, text: warehouse.name }));
    },

    formattedsuppliers() {
      return this.suppliers.map(supplier => ({ id: supplier.id, text: supplier.name }));
    },

    formattedcashtypes() {
      return this.cash_types.map(cash_type => ({ id: cash_type.id, text: cash_type.name }));
    },

    formattedbankaccounts() {
      return this.bank_accounts.map(bank_account => ({ id: bank_account.id, text: bank_account.name }));
    },

    isBank() {
      const val = this.cash_type;
      const id = val && typeof val === 'object' ? val.id : val;
      return String(id) === '1010102';
    },

    // Total of all batch amounts
    totalAmount() {
      return this.addedItems.reduce((sum, item) => {
        const amount = parseFloat(item.amount) || 0;
        return sum + amount;
      }, 0).toFixed(2);
    },

    // Due amount = Total - Paid
    dueAmount() {
      const total = parseFloat(this.totalAmount) || 0;
      const paid = parseFloat(this.paid) || 0;
      const due = total - paid;
      return (due < 0 ? 0 : due).toFixed(2);
    }
  },

  methods: {
      async fetchDropdownData() {
        try {
          const [
            itemRes, warehouseRes, supplierRes, cash_typeRes, receive_noRes, bank_accRes,
          ] = await Promise.all([
            this.$axios.get(apiUrls.item.get),
            this.$axios.get(apiUrls.inventory_warehouse.get),
            this.$axios.get(apiUrls.inventory_supplier.get),
            this.$axios.get(apiUrls.batch_cash_type.get),
            this.$axios.get(apiUrls.batch_receive_no.get),
            this.$axios.get(apiUrls.batch_bank_account.get)
          ]);

          this.items = itemRes?.data || [];
          this.warehouses = warehouseRes?.data || [];
          this.suppliers = supplierRes?.data || [];
          this.cash_types = cash_typeRes?.data || [];
          this.batches.receiving_no = receive_noRes?.data?.receiving_no || '';
          this.bank_accounts = bank_accRes?.data || [];

          if (this.cash_types.length > 0 && !this.cash_type) {
            this.cash_type = this.cash_types[0].id;
          }

          if (this.bank_accounts.length > 0 && !this.bank_account) {
            this.bank_account = this.bank_accounts[0].id;
          }

        } catch (error) {
          console.error('Error loading dropdown data:', error);
        }
      },

      async searchItems() {
        if (!this.query) {
          this.results = []
          return
        }

        try {
          const response = await this.$axios.get(apiUrls.batch_item_search.get, {
            params: { q: this.query }
          })
          const results = response.data.results || [];
          this.results = results;
          this.itemIndex = 0;

          if (
          results.length === 1 &&
          results[0].barcode_qr_code &&
          results[0].barcode_qr_code === this.query
        ) {
          await this.selectItem(results[0])
          return
        }

          // render feather icons
          await this.$nextTick(() => {
            if (window.feather) feather.replace()
          })
        } catch (error) {
          console.error('Search error:', error)
          this.results = []
        }
      },

      selectItem(item) {
        this.selectedItem = item
        this.query = item.item_name
        this.batches.item = item.id
        this.results = []
        this.itemIndex = 0;
      },

      handleKeys(event) {
        if (event.key === 'ArrowDown') {
          this.itemIndex = Math.min(this.itemIndex + 1, this.results.length - 1);
          event.preventDefault();
        } else if (event.key === 'ArrowUp') {
          this.itemIndex = Math.max(this.itemIndex - 1, 0);
          event.preventDefault();
        } else if (event.key === 'Enter') {
          const selectedProduct = this.results[this.itemIndex];
          if (selectedProduct) {
            this.selectItem(selectedProduct);
          }
          event.preventDefault();
        }
      },

      addItem() {
        if (!this.selectedItem) {
          this.toast.warning("Please select an item first.");
          return;
        }

        // Frontend validation before adding to list
        this.errors = {};
        const requiredFields = [
          "item", "chalan_no", "chalan_date", "supplier_id", "batch_no", "lot_no",
          "costing_unit_price", "quantity", "in_house_date",
          "manufacturing_date", "expiry_date", "warehouse_id", "receiving_date"
        ];
        requiredFields.forEach(field => {
          if (!this.batches[field]) this.errors[field] = this.$t('error.required');
        });

        if (Object.keys(this.errors).length > 0) {
          return;
        }

        // Store full batch data in addedItems
        const newItem = {
          ...this.batches,
          id: this.selectedItem.id,
          item_name: this.selectedItem.item_name,
          item_code: this.selectedItem.item_code,
          amount: (this.batches.costing_unit_price || 0) * (this.batches.quantity || 0),
          images: this.selectedItem.images || [],
        };

        this.addedItems.push(newItem);

        // Reset only row fields, not whole form structure
        this.batches = {
          item: null, chalan_no: this.batches.chalan_no, chalan_date: this.batches.chalan_date,
          supplier_id: this.batches.supplier_id, batch_no: '', lot_no: '',
          costing_unit_price: '', quantity: null, in_house_date: this.batches.in_house_date,
          manufacturing_date: null, expiry_date: null, warehouse_id: this.batches.warehouse_id,
          receiving_no: this.batches.receiving_no, receiving_date: this.batches.receiving_date,
        };
        this.errors = {};
        this.query = "";
        this.selectedItem = null;
      },

      async fetchReceivingNo() {
        try {
          let res = await this.$axios.get(apiUrls.batch_receive_no.get, {
            params: { receiving_date: this.batches.receiving_date }
          });
          this.batches.receiving_no = res.data.receiving_no;
        } catch (err) {
          console.error(err);
        }
      },

      openDueModal() {
        return new Promise((resolve) => {
          this.dueModalResolver = resolve;
          this.showDueModal = true;
        });
      },

      confirmDueSale() {
        this.showDueModal = false;
        if (this.dueModalResolver) this.dueModalResolver(true);
      },

      cancelDueSale() {
        this.showDueModal = false;
        if (this.dueModalResolver) this.dueModalResolver(false);
      },

      async submitBatch() {
        if (!this.addedItems.length) {
          this.toast.warning("Please add at least one batch before submitting.");
          return;
        }

        if (parseFloat(this.paid) > parseFloat(this.totalAmount)) {
          this.toast.warning("Paid amount cannot exceed total amount.");
          return;
        }

        if (isNaN(this.paid) || this.paid < 0) {
          this.toast.warning("Invalid paid amount.");
          return;
        }

        if (this.dueAmount > 0) {
          const confirmed = await this.openDueModal();
          if (!confirmed) {
            this.toast.info("Submission cancelled.");
            return;
          }
        }

        try {
          const payload = {
            batches: this.addedItems,
            payment: {
              paid: this.paid,
              due: this.dueAmount,
              reference_no: this.reference_no,
              cash_type: this.cash_type,
              bank_account: this.bank_account
            }
          };

          // if your API expects JSON
          const response = await this.$axios.post(apiUrls.inv_batch.post, payload );

          this.toast.success("Batches submitted successfully!");
          this.$router.push('/batches');
          this.$emit("create_success");
          this.resetForm();
          this.addedItems = [];
        } catch (error) {
          if (error.response?.data?.error) {
            this.errorMessage = error.response.data.error;
          }
          if (error.response?.data?.errors) {
            this.errors = error.response.data.errors;
          }
        }
      },

      async selectSupplier(value) {
        // dropdown gives only the supplier id
        const supplierId = value;

        if (!supplierId) {
          this.selectedSupplier = null;
          this.due_balance = 0;
          return;
        }

        // get full object from loaded array
        const supplierObj = this.formattedsuppliers.find((s) => s.id === supplierId);

        try {
          const response = await this.$axios.get(`/supplier/due/${supplierId}`);
          this.selectedSupplier = {
            ...supplierObj,
            due_balance: response.data.due_balance,
            name: response.data.supplier_name,
            phone_number: response.data.supplier_phone
          };
          this.due_balance = response.data.due_balance;
        } catch (error) {
          console.error("Error fetching due balance:", error);
          this.due_balance = 0;
        }
      },

      cancelForm() {
        this.$router.push('/batches');
      },

      removeItem(index) {
        this.addedItems.splice(index, 1);
      },

      resetForm() {
        // Reset form fields and errors
        this.batches = {
          item: '', chalan_no: '', chalan_date: '', supplier_id: '', batch_no: '', lot_no: '', costing_unit_price: '',
          quantity: '', in_house_date: '', manufacturing_date: '', expiry_date: '', warehouse_id: '',
          receiving_no: '', receiving_date: ''
        };
        this.errors = {};
        this.errorMessage = "";
        this.cash_type = this.formattedcashtypes.length > 0 ? this.formattedcashtypes[0].id : '';
        this.bank_account = null;
      }
    },

  watch: {
    'batches.receiving_date'(newDate) {
      if (newDate) {
        this.fetchReceivingNo();
      } else {
        this.batches.receiving_no = '';
      }
    },

    'cash_type'(newVal) {
      const id = newVal && typeof newVal === 'object' ? newVal.id: newVal;
      if (String(id) === '1010102') {
        if (this.bank_accounts.length > 0) {
          this.bank_account = this.bank_accounts[0].id;
        }
      } else {
        this.bank_account = null;
      }
    },

    isBank(newVal) {
      if (!newVal) this.bank_account = null;
    },
  },

  created() {
    this.debouncedSearch = debounce(this.searchItems, 300)
  },
};
</script>


<style scoped>
/* Optional: adjust table and input heights */
.table td, .table th {
  vertical-align: middle;
}

.fixed-table {
  min-height: 350px;
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 5px;
}

/* Modal Backdrop */
.confirm-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Modal Box */
.confirm-modal {
  width: 420px;
  background: #ffffff;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  animation: fadeInScale 0.2s ease;
}

/* Header */
.confirm-header h4 {
  text-align: center;
  margin-bottom: 20px;
  font-weight: 600;
}

/* Body Rows */
.confirm-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.confirm-row.due {
  color: #dc3545;
  font-weight: 600;
  font-size: 16px;
}

/* Buttons */
.confirm-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

/* Animation */
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

</style>

